/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BotResponse } from './BotResponse';
import {
    BotResponseFromJSON,
    BotResponseFromJSONTyped,
    BotResponseToJSON,
} from './BotResponse';

/**
 * 
 * @export
 * @interface StudentChatResponse
 */
export interface StudentChatResponse {
    /**
     * 
     * @type {string}
     * @memberof StudentChatResponse
     */
    id: string;
    /**
     * 
     * @type {BotResponse}
     * @memberof StudentChatResponse
     */
    data: BotResponse;
}

/**
 * Check if a given object implements the StudentChatResponse interface.
 */
export function instanceOfStudentChatResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function StudentChatResponseFromJSON(json: any): StudentChatResponse {
    return StudentChatResponseFromJSONTyped(json, false);
}

export function StudentChatResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudentChatResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'data': BotResponseFromJSON(json['data']),
    };
}

export function StudentChatResponseToJSON(value?: StudentChatResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'data': BotResponseToJSON(value.data),
    };
}

